<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <div class="text-xs-center">
      <svg-buttons @finished="$store.commit('nextShow', true)"/>
    </div>
    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
      'Modulo 3/AUDIO 08'
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgButtons from '../../assets/Modulo 3/diapositiva-8'
export default {
  components:{
    SvgButtons
  },
  data() {
    return {
      dialogos: [
        "Ahora conocerás los métodos determinísticos y probabilísticos. Sin importar el procedimiento analítico usado, las estimaciones de reservas y recursos se pueden realizar usando estos métodos, pero ¿qué fortalezas y debilidades presentan? <span class='instruccion'>Haz clic en el esquema</span> para conocer las fortalezas y debilidades del método determinístico." 
      ],
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  }
}
</script>
<style lang="scss" scoped>
</style>
